import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React from "react";

import {
  View,
  ScrollView,
  Heading,
  Text,
  Pressable,
  Box,
  VStack,
} from "native-base";
import Card, { CardProps } from "../../components/Card";
import { StackScreenProps } from "../../types";
import BottomSlidingImages from "../../components/BottomSlidingImages";
import Header from "../../components/Header";

const Index = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { height, width } = useWindowDimensions();

  const data: CardProps[] = [
    {
      heading: "Farm Initiatives",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("FarmInitiatives"),
      image: require("../../assets/vectors/handshake.png"),
    },
    {
      heading: "Digital",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("Digital"),
      image: require("../../assets/vectors/hub.png"),
    },

    {
      heading: "Media",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("Media"),
      image: require("../../assets/vectors/folder.png"),
    },
  ];

  const partners = [
    {
      image: require("../../assets/partners/palm-valley.png"),
      name: "Palm Valley",
    },
    { image: require("../../assets/partners/abumfb.png"), name: "ABUMFB" },
    { image: require("../../assets/partners/afex.png"), name: "AFEX" },
    { image: require("../../assets/partners/thrive.png"), name: "Thrive" },
    {
      image: require("../../assets/partners/arzikinnoma.png"),
      name: "Arzikin Noma",
    },
    { image: require("../../assets/partners/intrio.png"), name: "Intrio" },
    { image: require("../../assets/partners/archesa.png"), name: "Archesa" },
    { image: require("../../assets/partners/syngenta.png"), name: "Syngenta" },
    { image: require("../../assets/partners/picture1.png"), name: "" },
    { image: require("../../assets/partners/picture2.png"), name: "" },
    { image: require("../../assets/partners/agra.png"), name: "AGRA" },
    { image: require("../../assets/partners/olam.png"), name: "OLAM" },
    { image: require("../../assets/partners/agrolog.png"), name: "AgroLog" },
    {
      image: require("../../assets/partners/tweakcentric.png"),
      name: "TWEAKCENTRIC",
    },
    { image: require("../../assets/partners/insigna.png"), name: "INSIGNA" },
  ];

  return (
    <ImageBackground
      source={require("../../assets/background.png")}
      resizeMode="repeat"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView
            px={5}
            contentContainerStyle={{
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <View>
              <Header
                onPress={() => navigation.navigate("Home")}
                headingText="Farmer-Centric Projects"
                parentText=""
                intro="At OCP Africa, we believe in Africa self-sustenance in food production and we believe that smallholder farmers have a huge role to play in our food system that’s is we invest in farmer-centric projects that improve the income and livelihood of smallholder farmers."
              />
              <View justifyContent="center" mt={5} mb={5}>
                <Pressable
                  bg="#01CD51"
                  borderRadius={15}
                  p={1}
                  w={220}
                  margin="auto"
                  style={styles.buttonShadow}
                  onPress={() => navigation.navigate("HubMap")}
                >
                  <Text textAlign={"center"}>Locate Hubs across Nigeria</Text>
                </Pressable>
              </View>

              {data.map((item) => (
                <Pressable key={item.heading} mb={10} onPress={item.onPress}>
                  <Card
                    heading={item.heading}
                    subheading={item.subheading}
                    details={item.details}
                    iconName={item.iconName}
                    onPress={item.onPress}
                    borderBottomColor="#333333ac"
                    borderColor="#aaa"
                    bg="#007C6B"
                    image={item.image}
                  />
                </Pressable>
              ))}
            </View>

            <BottomSlidingImages partners={partners} />
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Index;

const styles = StyleSheet.create({
  shadow: {
    shadowOffset: { width: 0, height: 20 },
    shadowRadius: 20,
    shadowOpacity: 0.6,
    shadowColor: "#000000",
    elevation: 20,
  },
  buttonShadow: {
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 1,
    shadowOpacity: 0.3,
    shadowColor: "#000000",
    elevation: 5,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 127, 109, 0.5)",
  },
});
